import React, { useState, useEffect } from "react";
import Images from "../../Images";
import Spinner from "../Spinner/spinner";
import BottomText from "../BottomText";
import "./style.css";
import $ from "jquery";
import ExternalAuth from "../ExternalAuth";
import { storeToken } from "../../authetication/loginState";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useAnalyticsEventTracker from "../../helper/reactTracker";
import { Typography } from "@material-ui/core";
import ForgotPassModal from "./forgotPassModal";
import login_img from "../../images/homepage/loginScreenImage.png";
import { useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const LoginForm = ({ loginState }, props) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [isSignup, setIsSignup] = useState(true);
  const [password, setPassword] = useState("");
  const [needNewEmail, setNeedNewEmail] = useState("");
  const [isWrongCredentials, setIsWrongCredentials] = useState("false");
  const [isGoogleSigninError, setIsGoogleSigninError] = useState("false");
  const [hidden, setHidden] = useState("false");
  let navigate = useNavigate();
  const location = useLocation();
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loggingIn, setLoggingIn] = useState("");
  const [signingUp, setSigningUp] = useState("");
  const [userType, setUserType] = useState("student");
  const gaEventTracker = useAnalyticsEventTracker("Register");
  const [showPassModal, setShowPassModal] = useState(false);
  const [hasEightChars, setHasEightChars] = useState(false);
  const [containNums, setContainNums] = useState(false);
  const [containUpperCase, setContainUpperCase] = useState(false);
  const [containLowerCase, setContainLowerCase] = useState(false);
  const [containNonAlphaNumeric, setContainNonAlphaNumeric] = useState(false);
  const { referredFrom, userReferred } = location.state || {};

  //end points
  const registerEndpoint = process.env.REACT_APP_REGISTER_ENDPOINT;
  const loginEndpoint = process.env.REACT_APP_LOGIN_ENDPOINT;

  const isMobile = useMediaQuery('(max-width:600px)');

  // Meta Pixel tracking for signup page view
  useEffect(() => {
    if (isSignup && window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, [isSignup]);

  const handlePasswordRestraintCheck = (e) => {
    const value = e.target.value;
    
    if (value.length < 8) {
      setHasEightChars(false);
    } else {
      setHasEightChars(true);
    }

    const regexForNum = /\d/;
    const regexForUpperCase = /[A-Z]/;
    const regexForLowerCase = /[a-z]/;
    const regexForNonAlphaNumeric = /[^a-zA-Z0-9]/g;

    if (regexForNum.test(value)) {
      setContainNums(true);
    } else {
      setContainNums(false);
    }

    if (regexForUpperCase.test(value)) {
      setContainUpperCase(true);
    } else {
      setContainUpperCase(false);
    }

    if (regexForLowerCase.test(value)) {
      setContainLowerCase(true);
    } else {
      setContainLowerCase(false);
    }

    if (regexForNonAlphaNumeric.test(value)) {
      setContainNonAlphaNumeric(true);
    } else {
      setContainNonAlphaNumeric(false);
    }

    setPassword(value);
  };

  const validateError = () => {
    setNameError("");
    setEmailError("");
    setPasswordError("");
    let reNameError = "";
    let reEmailError = "";
    let rePasswordError = "";
    setNeedNewEmail("");
    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;

    if (name === "") {
      reNameError = "Name cannot be empty";
      setNameError(reNameError);
    }

    if (email === "") {
      reEmailError = "Email cannot be Empty";
      setEmailError(reEmailError);
    }
    if (password === "") {
      rePasswordError = "Password cannot be empty";
      setPasswordError(rePasswordError);
    }

    if (!email.includes("@") && email !== "") {
      reEmailError = "Invalid Email";
      setEmailError(reEmailError);
    }

    if (!password.match(regex) && password !== "") {
      rePasswordError =
        "Must have password with min 8 characters containing atleast one uppercase letter, one lowercase, one number and one special character";
      setPasswordError(rePasswordError);
    }

    if (rePasswordError === "" && reEmailError === "" && reNameError === "") {
      return false;
    }

    return true;
  };

  const login = (e) => {
    e.preventDefault();
    $.ajaxSetup({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    setLoggingIn("user logging in");

    let m = $.post(
      `${loginEndpoint}`,
      JSON.stringify({ Email: email, Password: password }),
      (data) => {
        localStorage.setItem("userEmail", email);
        localStorage.setItem("userName", data.name); 
        if (data.userId) localStorage.setItem("userId", data.userId);
        if (data.userReferred) localStorage.setItem("userReferred", data.userReferred);
        if (data.referredFrom) localStorage.setItem("referredFrom", data.referredFrom);
        setIsWrongCredentials("false");
        
        // Meta Pixel tracking for successful login
        if (window.fbq) {
          window.fbq('track', 'Contact');
        }
        
        storeToken(data);
        loginState.setLoggedIn(true);
        navigate("/mockInterviewerInput");
      }
    ).fail((data2) => {
      if (data2.status === 401) {
        setIsWrongCredentials("true");
        setLoggingIn("");
        document.getElementById("wrongCredentials").style.display = "block";
        document.getElementById("userSessionExpired").style.display = "none";
      }
    });
  };

  const passShowHide = (e) => {
    e.preventDefault();
    if (hidden === "false") {
      setHidden("true");
    } else {
      setHidden("false");
    }
  };

  const userSessionPrompt = () => {
    if (location.state === "userSessionExpired") {
      location.state = "done";
    }
  };

  const register = (e) => {
    // Insert Loader here
    e.preventDefault();

    setSigningUp("user signing up");

    let registerNotOk = validateError();

    if (registerNotOk) {
      document.getElementById("invalidSignUp").style.display = "block";
      document.getElementById("userSessionExpired").style.display = "none";
      setTimeout(() => setSigningUp(""), 500);
    } else {
      document.getElementById("invalidSignUp").style.display = "none";
      setSigningUp("user signing up");

      $.ajaxSetup({
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      $.post(
        `${registerEndpoint}`,
        JSON.stringify({ 
            Name: name, 
            Email: email, 
            Password: password,
            UserReferred: userReferred || false,     
            ReferredFrom: referredFrom || null        
        }),
        (res) => {
          $.post(
            `${loginEndpoint}`,
            JSON.stringify({ Email: email, Password: password }),
            (data) => {
              gaEventTracker("register");
              localStorage.setItem("userEmail", email);
              localStorage.setItem("userName", data.name); 
              
              // Meta Pixel tracking for successful registration
              if (window.fbq) {
                window.fbq('track', 'CompleteRegistration');
              }
              
              storeToken(data);
              loginState.setLoggedIn(true);
              navigate("/onboarding");
            }
          ).fail((data2) => {
            setSigningUp("");
          });
        }
      ).fail((data3) => {
        if (!registerNotOk) {
          setNeedNewEmail("Email already exists");
        }
        document.getElementById("invalidSignUp").style.display = "block";
        document.getElementById("userSessionExpired").style.display = "none";
        setSigningUp("");
      });
    }
  };

  const trueForgotModal = (event) => {
    event.preventDefault();
    setShowPassModal(true);
  };

  const falseForgotModal = () => {
    setShowPassModal(false);
  };

  return (
    <>
      <div>{loggingIn === "user logging in" ? <Spinner /> : <p></p>}</div>
      <div>{signingUp === "user signing up" ? <Spinner /> : <p></p>}</div>
      <div
        className="bg-img-login"
        style={{
          backgroundRepeat: "repeat-y",
          backgroundSize: "cover",
          minWidth: "100vw",
          minHeight: "100vh",
        }}
      >
        <img
          className="ig-logo"
          src={Images.NORA_LOGO}
          alt="Nora AI"
          onClick={() => navigate("/")}
        />

        {showPassModal && <ForgotPassModal clickOutside = {falseForgotModal}/>}

        <form 
          onSubmit={isSignup ? register : login}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (!isSignup) {
                login(e);  // Trigger login when Enter is pressed
              } else {
                register(e); // Trigger signup if it's a signup form
              }
            }
          }}
          >
        <div className="white-box">
          <div className="grid-wrapper">
            {isMobile ? ' ' : (
              <div className="login-pic-wrap">
                <img className="login-pic" src={login_img} />
              </div>
            )}
            <div className="login-details">
              <h1 className="title">
                Welcome to the Future of Interview Prep
              </h1>

              <div id="wrongCredentials">
                <h3>Invalid Credentials</h3>
                <h4>Either the email or the password is incorrect</h4>
              </div>

              <div id="invalidSignUp">
                <h3>Invalid Input</h3>
                <h4>{nameError}</h4>
                <h4>{emailError}</h4>
                <h4>{needNewEmail}</h4>
                <h4>{passwordError}</h4>
              </div>

              {location.state === "userSessionExpired" ? (
                userSessionPrompt()
              ) : (
                <p></p>
              )}

              <div
                id="userSessionExpired"
                style={
                  location.state === "done"
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <h3>User Session Expired</h3>
                <h4>Please log in again</h4>
              </div>

              <div id="googleSigninError">
                <h3>Google Sign-in Failed</h3>
                <h4>Unable to sign in with Google. Please try again.</h4>
              </div>

              <div className="text-fields-container">
                {isSignup === true ? (
                  <div className="text-input-signup">
                    <input
                      variant="outlined"
                      placeholder="Name"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      name="name"
                      className="text-input"
                    />
                  </div>
                ) : null}

                <div className="text-input-signup">
                  <input
                    id="outlined-basic"
                    type="email"
                    variant="outlined"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="text-input"
                    name="email"
                  />
                </div>

                {/* Password validation indicators */}
                {isSignup && (
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!hasEightChars ? (
                          <FontAwesomeIcon icon={faCircle} style={{ fontSize: '10px' }} />
                        ) : (
                          <FontAwesomeIcon icon={faCheckCircle} color='green' style={{ fontSize: '10px' }} />
                        )}
                        <span style={{ fontSize: '12px' }}>Min 8 characters</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!containNums ? (
                          <FontAwesomeIcon icon={faCircle} style={{ fontSize: '10px' }} />
                        ) : (
                          <FontAwesomeIcon icon={faCheckCircle} color='green' style={{ fontSize: '10px' }} />
                        )}
                        <span style={{ fontSize: '12px' }}>Contains numbers</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!containUpperCase ? (
                          <FontAwesomeIcon icon={faCircle} style={{ fontSize: '10px' }} />
                        ) : (
                          <FontAwesomeIcon icon={faCheckCircle} color='green' style={{ fontSize: '10px' }} />
                        )}
                        <span style={{ fontSize: '12px' }}>Contains uppercase letters</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!containLowerCase ? (
                          <FontAwesomeIcon icon={faCircle} style={{ fontSize: '10px' }} />
                        ) : (
                          <FontAwesomeIcon icon={faCheckCircle} color='green' style={{ fontSize: '10px' }} />
                        )}
                        <span style={{ fontSize: '12px' }}>Contains lowercase letters</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!containNonAlphaNumeric ? (
                          <FontAwesomeIcon icon={faCircle} style={{ fontSize: '10px' }} />
                        ) : (
                          <FontAwesomeIcon icon={faCheckCircle} color='green' style={{ fontSize: '10px' }} />
                        )}
                        <span style={{ fontSize: '12px' }}>Contains non-alphanumeric</span>
                      </div>
                    </div>
                  </div>
                )}

                <div className="text-input-signup">
                  <input
                    id="outlined-basic"
                    variant="outlined"
                    label="Password"
                    placeholder="Password"
                    className="text-input"
                    type={hidden === "false" ? "password" : "text"}
                    value={password}
                    onChange={(e) => isSignup ? handlePasswordRestraintCheck(e) : setPassword(e.target.value)}
                    name="password"
                  />
                  <img
                    className={!isSignup ? "lg-eyeicon" : "eyeicon"}
                    src={
                      hidden === "false" ? Images.EYE_CLOSED : Images.EYE_OPEN
                    }
                    alt="password-visibility"
                    onClick={(e) => passShowHide(e)}
                  />
                </div>
              </div>
              
              <p className="password_forgot">
                <button
                  className="login__forgot-link"
                  onClick={trueForgotModal}
                >
                  Forgot Password?
                </button>
              </p>

              <button type="submit" className="login-loginbtn">
                {isSignup ? "Sign up" : "Login"}
              </button>

              {isWrongCredentials === "true" && (
                <p className="wrongInfo">
                </p>
              )}

       
              <div className="divider">
              <hr />
              <span>OR</span>
              <hr />
              </div>
              
              <ExternalAuth isSignup={isSignup} loginState={loginState} navigate={navigate} setIsGoogleSigninError={setIsGoogleSigninError} />
          

              {isMobile ? (
                <>
                  <BottomText>
                    {isSignup ? (
                      <div className="btm-text">
                        <Typography variant="h5" className="mx-2">
                          Already have an account?
                        </Typography>
                        <span
                          className="login-text"
                          onClick={() => {
                            setIsSignup(false);
                            document.getElementById("wrongCredentials").style.display = "none";
                            document.getElementById("invalidSignUp").style.display = "none";
                            document.getElementById("userSessionExpired").style.display =
                              "none";
                          }}
                          style={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            color: "#7d994d",
                            textDecoration: "none",
                            paddingBottom: "2px",
                          }}
                        >
                          Log in
                        </span>
                      </div>
                    ) : (
                      <div className="btm-text">
                        <Typography variant="h5" className="mx-2">
                          New Member?
                        </Typography>
                        <span
                          onClick={() => {
                            setIsSignup(true);
                            document.getElementById("wrongCredentials").style.display = "none";
                            document.getElementById("invalidSignUp").style.display = "none";
                          }}
                          style={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            color: "#7D994D",
                            textDecoration: "none",
                          }}
                        >
                          Sign up
                        </span>
                      </div>
                    )}
                  </BottomText>
                </>
              ) : (
                <>
                  <BottomText>
                        {isSignup ? (
                          <div className="btm-text">
                            <Typography variant="h5" className="mx-2">
                              Already have an account?
                            </Typography>
                            <span
                              onClick={() => {
                                setIsSignup(false);
                                document.getElementById(
                                  "wrongCredentials"
                                ).style.display = "none";
                                document.getElementById("invalidSignUp").style.display =
                                  "none";
                                document.getElementById(
                                  "userSessionExpired"
                                ).style.display = "none";
                              }}
                              style={{
                                fontWeight: "bold",
                                cursor: "pointer",
                                color: "#7d994d",
                                textDecoration: "none",
                                paddingBottom: "2px"
                              }}
                            >
                              Log in
                            </span>
                          </div>
                        ) : (
                          <div className="btm-text">
                            <Typography variant="h5" className="mx-2">
                              New Member?
                            </Typography>
                            <span
                              onClick={() => {
                                setIsSignup(true);
                                document.getElementById(
                                  "wrongCredentials"
                                ).style.display = "none";
                                document.getElementById("invalidSignUp").style.display =
                                  "none";
                              }}
                              style={{
                                fontWeight: "bold",
                                cursor: "pointer",
                                color: "#7d994d",
                                textDecoration: "none",
                              }}
                            >
                              Sign up
                            </span>
                          </div>
                        )}
                  </BottomText>
                </>
              )}
            </div>
          </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginForm;
